module.exports = __webpack_public_path__ + "static/clive_profile-bff8f838e7a2f058a319828869f4a7ab.jpg";